import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import BookmarkBorderRoundedIcon from '@mui/icons-material/BookmarkBorderRounded';
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded';
import { Link as RouterLink } from 'react-router-dom';

const PROCESSING_STATUSES = new Set(['captured', 'pending', 'organizing']);

const MessageLifelogAction = ({
  message,
  promotionState,
  isAdding = false,
  isAdded = false,
  addFailed = false,
  onAdd,
  onRetry,
  navigationState = null,
  isOwnMessage = false,
}) => {
  const processingStatus = promotionState?.processingStatus || promotionState?.status;
  const isProcessing = Boolean(promotionState && PROCESSING_STATUSES.has(processingStatus));
  const hasRetryableFailure = Boolean(promotionState && (
    promotionState.status === 'extraction_failed' || processingStatus === 'extraction_failed'
  ));
  const needsReview = promotionState?.reviewState === 'needs_review' || promotionState?.reviewState === 'ready_to_save';
  const actionSx = {
    width: '100%',
    minHeight: 48,
    px: 2,
    py: 1,
    justifyContent: 'flex-start',
    borderRadius: 0,
    textTransform: 'none',
    fontWeight: 800,
    color: 'primary.dark',
    '& .MuiButton-startIcon': { mr: 1 },
  };

  const actionStrip = (content) => (
    <Box
      data-testid="lifelog-action-strip"
      sx={{
        mx: -2,
        mb: -1.4,
        mt: 1.25,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: isOwnMessage ? 'rgba(53, 122, 98, 0.08)' : 'transparent',
        overflow: 'hidden',
      }}
    >
      {content}
    </Box>
  );

  if (isProcessing) {
    return actionStrip(
      <Button
        component={RouterLink}
        to={`/sources/${promotionState.sourceNoteId}`}
        state={navigationState}
        variant="text"
        startIcon={<BookmarkRoundedIcon />}
        sx={actionSx}
      >
        Organizing in Lifelog · View status
      </Button>
    );
  }
  if (hasRetryableFailure) {
    return actionStrip(
      <Button variant="text" disabled={isAdding} onClick={() => onRetry?.(message)} startIcon={isAdding ? <CircularProgress size={16} /> : <BookmarkBorderRoundedIcon />} sx={actionSx}>
        {isAdding ? 'Retrying…' : 'Try adding to Lifelog again'}
      </Button>
    );
  }
  if (promotionState) {
    return actionStrip(
      <Button component={RouterLink} to={`/sources/${promotionState.sourceNoteId}`} state={navigationState} variant="text" startIcon={<BookmarkRoundedIcon />} sx={actionSx}>
        {needsReview ? 'In Lifelog · Review' : 'In Lifelog · View'}
      </Button>
    );
  }
  return actionStrip(
    <Button variant="text" disabled={isAdding || isAdded} onClick={() => onAdd?.(message)} startIcon={isAdding ? <CircularProgress size={16} /> : <BookmarkBorderRoundedIcon />} sx={actionSx}>
      {isAdded ? 'Added to Lifelog' : isAdding ? 'Adding…' : addFailed ? 'Try adding to Lifelog again' : 'Add to Lifelog'}
    </Button>
  );
};

export default MessageLifelogAction;
